export const attendee = '/MersetaLAIAttendee';
export const allocatedAttendees = attendee + '/AllocatedAttendees/';
export const getAllUnassociatedAttendee = attendee + '/AllUnassociatedAttendee/';
